<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <div data-app>
    <chat-context-site-header
      :message-search-url="headerInfo.messageSearchUrl"
      :site-name="headerInfo.siteName"
      :site-id="headerInfo.siteId"
      :has-chat-site-notes="headerInfo.hasChatSiteNotes"
      :in-watchlist="siteInWatchlist"
      :site-url="siteUrl"
    />
    <pagination-component
      itemName="Message"
      :loading="loading"
      :totalItems="totalMessages"
      :showNavOptions="true"
      :initialParams="initialParams"
      :sortOptions="sortOptions"
      :syncPaginationControls="performPaginationSync"
      @syncPaginationControls="syncPagination"
      @performSearch="fetchChatMessages"
    />
    <div
      v-if="loading"
      class="alert alert--info u-text-centre"
    >
      {{ gettext('Loading...') }}
    </div>
    <div class="notes-legend">
      <notes-legend />
    </div>
    <div
      v-if="!loading && totalMessages > 0"
      id="search-results"
      class="timeline"
    >
      <chat-context-item
        v-for="(message, index) in chatMessages"
        :key="index"
        :message="message"
        :message-search-url="messageSearchUrl"
        :media-search-url="mediaSearchUrl"
        :site-name="siteName"
        :timeframe="timeframe"
        :featured="message._id === docId"
        @refreshed="fetchChatMessages"
        @target="target"
      />
    </div>

    <pagination-component
      itemName="Message"
      :loading="loading"
      :isPrimary="false"
      :totalItems="totalMessages"
      :syncPaginationControls="performPaginationSync"
      @syncPaginationControls="syncPagination"
      @performSearch="fetchChatMessages"
    />
  </div>
</template>

<script>
import ChatContextSiteHeader from './ChatContextSiteHeader'
import ChatContextItem from './ChatContextItem'
import NotesLegend from '../notes/NotesLegend'
import PaginationComponent from '../PaginationComponent'
import axios from 'axios'
import Cookies from 'js-cookie'

export default {
  name: 'ChatContextView',

  components: {
    ChatContextSiteHeader,
    ChatContextItem,
    NotesLegend,
    PaginationComponent,
  },

  props: {
    docId: {
      type: String,
      default: ''
    },
    siteId: {
      type: String,
      required: true
    },
    messageSearchUrl: {
      type: String,
      required: true
    },
    siteName: {
      type: String,
      required: true
    },
    mediaSearchUrl: {
      type: String,
      required: true
    },
    headerInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chatMessages: [],
      siteUrl: '',
      loading: true,
      totalMessages: 0,
      timeframe: '1209600',
      siteInWatchlist: false,
      initialParams: {
        start: 0,
        limit: 25,
        sort: '-posted_date'
      },
      sortOptions: {
        '-posted_date': 'Most Recent',
      },
      performPaginationSync: false,
    }
  },
  computed: {
    chatIndexURL() {
      return `/en/indices/${this.siteName}/chat_index/`
    },
  },
  mounted() {
    this.scrollToFeatured()
  },
  methods: {
    syncPagination(performSync) {
      this.$nextTick(() => {
        this.performPaginationSync = performSync
      })
    },
    scrollToFeatured() {
      if (this.$el.querySelector('.timeline__focus')) {
        // need to use $nextTick so that the coordinates are correct. Otherwise the offsetTop reported by the elements
        // is incorrect if they land after a "long post" that uses the "tldr" button and overflow:hidden to clip the
        // post content. This way the DOM is fully rendered and we have the coordinate from the actual visible elements.
        this.$nextTick(() => {
          window.scrollTo({
            top: this.$el.querySelector('.timeline__focus').offsetTop,
            behavior: 'smooth',
          })
        })
      }
    },
    fetchChatMessages() {
      this.loading = true

      let searchParams = new URLSearchParams(window.location.search)
      // unfortunately we need to convert search params object into a regular js
      // object so it may be passed into request
      let requestParams = {}
      for (const [key, value] of searchParams) {
        requestParams[key] = value
      }

      const csrftoken = Cookies.get('csrftoken')
      axios.get(this.chatIndexURL, {'headers': {'X-CSRFToken': csrftoken}, 'params': requestParams})
        .then(response => {
          this.chatMessages = response.data.messages
          // ES 9 is under .value
          this.totalMessages = response.data.total.value
          this.siteInWatchlist = this.chatMessages[0].site_watchlist
          this.siteUrl = this.chatMessages[0].url
        })
        .catch(error => {
          console.log(error)
          this.chatMessages = []
          this.totalMessages = 0
        }).finally(() => {
          this.loading = false
        })
    },
    target(message) {
      window.location = `${this.messageSearchUrl}chat-sites/${this.siteName}/${message.messageId}/?timeframe=${this.timeframe}`
    }
  },
}
</script>

<style scoped>
.chat-message-num-selector input {
  min-width: 3.5em;
  width: 3.5em;
  text-align: center;
  margin: 0 5px;
}
.chat-message-num-selector button {
  background: #696463;
  color: #fff;
  padding: 0.5em 1.125em;
  border-radius: 5px;
  margin-left: 5px;
}
.notes-legend {
  margin-right: 14rem;
}
</style>
